import completeProgress from "./ProgressTestValues";

export class ProgressBase {
    constructor ( dataStore ) {
        this.dataStore = dataStore
    }

    // Returns a promise
    retrieve() {
        return this.dataStore.retrieve()
    }

    // Returns a promise
    store(progresses) {
        return this.dataStore.store(progresses)
    }

    // Returns a promise
    retrieveTest() {
        return new Promise((resolve, reject) => {
            resolve(completeProgress)
        })
    }

}

export default ProgressBase